import { render, staticRenderFns } from "./child.vue?vue&type=template&id=1d994df0&scoped=true&"
import script from "./child.vue?vue&type=script&lang=js&"
export * from "./child.vue?vue&type=script&lang=js&"
import style0 from "./child.vue?vue&type=style&index=0&id=1d994df0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d994df0",
  null
  
)

export default component.exports